import { IMG_PREFIX } from "@/config/index";
import QRCode from "qrcode";
import { v4 as uuidv4 } from "uuid";

/**
 * 获取多个？？url参数
 */
export const getQueryParams = (key) => {
  const hash = location.hash || "";
  const paramSegments = hash.split("?").slice(1); // 忽略第一个分段（路由路径）
  const paramString = paramSegments.join("&"); // 将多个参数段合并

  const params = new URLSearchParams(paramString);

  if (key) {
    return params.get(key) || "";
  }

  return Object.fromEntries(params.entries());
};

/**
 * 判断是否是移动端
 */
export const isNotWidthPhone = () => {
  return isAndroid() || isIOS();
};

/**
 * 判断是否是安卓客户端
 */
export const isAndroid = () => {
  const ua = window.navigator.userAgent || "";
  return !!ua.match(/(Android);?[\s/]+([\d.]+)?/i);
};

/**
 * 判断是否是IOS客户端
 */
export const isIOS = () => {
  const ua = window.navigator.userAgent || "";
  return !!ua.match(/iPhone/i);
};

/**
 *
 * @returns 是否是微信
 */
export const isInWeChatWork = () => {
  if (window.navigator.userAgent.indexOf("MicroMessenger") !== -1) {
    return true;
  }
  return false;
};

/**
 *
 * @returns 是否是QQ
 */
export const isInQQWork = () => {
  if (window.navigator.userAgent.indexOf("QQ") !== -1) {
    return true;
  }
  return false;
};

/**
 *
 * @param url 获取图片地址
 * @returns
 */
export const getServerStaticUrl = (url) => {
  if (!url.includes("http") && !url.includes("https")) {
    return `${IMG_PREFIX}${url}`;
  }
  return url;
};

/**
 *
 * @param htmlString 更新html img url
 * @returns
 */
export const updateHtmlBodyImgUrl = (htmlString) => {
  // 正则增强：同时处理img/source标签，捕获全部属性
  return htmlString.replace(
    /<(img|source)([^>]*?)(src|srcset)=(["'])(.*?)\4([^>]*)>/gis,
    (match, tag, prefixAttr, attrName, quote, srcValue, suffixAttr) => {
      // 处理src/srcset属性
      const isSrcset = attrName.toLowerCase() === "srcset";
      const dataAttr = isSrcset ? "data-srcset" : "data-src";
      const newValue = getServerStaticUrl(srcValue);

      // 构建新属性
      const newAttributes = [
        prefixAttr.trim(),
        `${dataAttr}=${quote}${newValue}${quote}`,
        suffixAttr.trim(),
      ].join(" ");

      // 添加懒加载属性
      const lazyLoading = !/loading=(["'])/i.test(match)
        ? 'loading="lazy"'
        : "";

      // 处理占位符（仅对src属性）
      const placeholderSrc = !isSrcset ? `src=${quote}${newValue}${quote}` : "";

      return `<${tag} ${newAttributes} ${lazyLoading} ${placeholderSrc}>`;
    }
  );
};

/**
 * 生成二维码图片的DataURL
 * @param {string} text - 二维码内容
 * @param {object} [options] - 自定义选项
 * @returns {Promise<string>} 图片的DataURL
 */
export const generateQRCode = (text, options = {}) => {
  try {
    // 默认配置
    const defaultOptions = {
      width: 300,
      margin: 1,
      color: {
        dark: "#000000ff", // 二维码颜色 (RGBA)
        light: "#ffffffff", // 背景颜色 (RGBA)
      },
      errorCorrectionLevel: "H", // 容错级别：L(7%), M(15%), Q(25%), H(30%)
    };

    // 合并配置
    const mergedOptions = { ...defaultOptions, ...options };

    return QRCode.toDataURL(text, mergedOptions);
  } catch (error) {
    console.error("生成二维码失败:", error);
    throw error;
  }
};

export const getGithubUrl = () => {
  const domain = window.location.hostname;
  if (domain === "sarosgame.com") {
    return `https://world.gh.sarosgame.com`;
  } else {
    return `https://world.guihuan.cn`;
  }
};

/**
 * URL为hash模式下获取参数
 * @returns
 */
export const getHashParams = (key) => {
  // const arr = (location.hash || '').replace(/^#\/\?/, '').split('&');
  if (location.hash.indexOf("?") === -1) return "";

  const arrayList = (location.hash || "").split("?");
  const arr = arrayList.length ? arrayList[1].split("&") : [];

  const params = {};
  for (let i = 0, l = arr.length; i < l; i++) {
    const index = arr[i].indexOf("=");
    const _key = arr[i].substring(0, index);
    const _value = decodeURIComponent(arr[i].substring(index + 1));
    params[_key] = _value;
  }
  if (key) {
    return params[key];
  }
  return params;
};

/**
 * 获取UID
 * @returns
 */
export const getUid = () =>
  localStorage.getItem("UID") ? localStorage.getItem("UID") : "";

/**
 *
 * @returns 获取设备id
 */
export const getDeviceId = () => {
  let deviceId = localStorage.getItem("DEVICE_ID")
    ? localStorage.getItem("DEVICE_ID")
    : "";
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem("DEVICE_ID", deviceId);
  }
  return deviceId;
};

/**
 *
 * @returns 设备类型
 */
export const getDeviceType = () => {
  return isAndroid() ? 1 : isIOS() ? 2 : 3;
};
